// Clickable column header for admin tables. Click toggles asc/desc on the
// column; the active column shows a ▲/▼ indicator. Server-side sorting —
// the parent passes the chosen (column, order) to the list hook.

import { clsx } from "clsx";

interface SortableHeaderProps {
  label: string;
  /** The server-side sort_by key this column maps to. */
  column: string;
  active: string | undefined;
  order: "asc" | "desc";
  onSort: (column: string) => void;
}

export function SortableHeader({
  label,
  column,
  active,
  order,
  onSort,
}: SortableHeaderProps) {
  const isActive = active === column;
  return (
    <button
      type="button"
      onClick={() => onSort(column)}
      className={clsx(
        "flex items-center gap-1 bg-transparent border-none p-0 cursor-pointer",
        "font-mono text-[10px] uppercase tracking-[0.05em] font-semibold text-left",
        isActive ? "text-accent" : "text-muted hover:text-content",
      )}
    >
      <span>{label}</span>
      <span className="text-[8px]">
        {isActive ? (order === "asc" ? "▲" : "▼") : "↕"}
      </span>
    </button>
  );
}
